import type { ResourceQuery } from 'infrastructure/api'
import { doAdminQueries } from 'infrastructure/api'

type DistrictResponse = {
  id: string
  name: string
  is_verified: boolean
  email_disabled: boolean
  created_at: string
  deleted_at?: string
  lms_type?: string
  notes?: string
  features: { id: number; name: string }[]
  curriculumsAddedOnSchoolLevel: {
    name: string
    tree_id: string
    school_count: number
  }[]
}

export async function fetchDistrict(id: number) {
  const queryKey = 'district'
  const resourceData: ResourceQuery = {
    key: queryKey,
    fields: [
      'id',
      'name',
      'is_verified',
      'email_disabled',
      'created_at',
      'deleted_at',
      'lms_type',
      'notes',
      { features: ['id', 'name', 'locked', 'free_trial'] },
      {
        curriculumsAddedOnSchoolLevel: ['name', 'tree_id', 'school_count'],
      },
    ],
  }
  const params = { id }
  const response = await doAdminQueries<DistrictResponse>(
    [{ resourceData, params }],
    false,
  )
  return response.data?.[queryKey]
}
